import "./err404.scss";

const Err404 = function () {
  return (
    <div className="err_container">
      <div className="err_wrapper">
        <h1>404</h1>
        <p>صفحه مورد نظر یافت نشد</p>
      </div>
    </div>
  );
};

export default Err404;
